<template>
    <div>

        <!--

        INCOMING IS BASICALLY:
            GET ME EVERYTHING WHICH IS COMING IN MY LOCATION FOR:
                1. DELIVERY TO CUSTOMER (EITHER VIA DELIVERY OR STORE PICKUP) (DROP_LOCATION = LOCATION_ID)
                2. COMING AS INVENTORY ITEM FROM VENDOR ORDER OR PURHCASE ORDER (TO BE ADDED) (LOCSUB = LOCATION_ID)

        -->
        <b-modal id="modal-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
            <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
        </b-modal>

        <div style="width: 100%;">
            <div>
                <div class="d-flex flex-wrap" style="gap: 7px;">
                    <b-alert variant="secondary" show style="display: inline-block; vertical-align: top;">


                        <div v-if="this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id" style="display: inline-block; vertical-align: top;">
                            <b-form-select size="sm" :options="get_locations()" v-model="drop_location">
                                <template #first>
                                    <b-form-select-option  :value="null" disabled>-- COMING TO --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;">
                            <b-button variant="success" style="display: inline-block;" size="sm" @click="fetch_init2">SEARCH</b-button>
                        </div>
                    </b-alert>

                    <div
                      v-if="isMobile && items.length > 0"
                      class="d-flex justify-content-between align-items-center mb-2 px-1"
                    >
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="filtersVisible = !filtersVisible"
                      >
                        <b-icon-funnel-fill class="mr-1" />
                        {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
                      </b-button>
                    </div>

                    <b-collapse :visible="!isMobile || filtersVisible">

                      <b-alert
                        variant="primary"
                        show
                        style="display: flex; flex-wrap: wrap; gap: 7px; vertical-align: top; padding: 13px;"
                        v-if="items.length > 0"
                      >

                        <!-- Date Filter -->
                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_date"
                            :options="available_dates"
                            size="sm"
                            style="width: 180px;"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- SELECT DATE --</b-form-select-option>
                              <b-form-select-option :value="null">ALL DATES</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <!-- Driver Filter -->
                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_driver"
                            :options="available_drivers"
                            size="sm"
                            style="width: 180px;"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- SELECT DRIVER --</b-form-select-option>
                              <b-form-select-option :value="null">ALL DRIVERS</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <!-- Status Filter -->
                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_status"
                            :options="available_statuses"
                            size="sm"
                            style="width: 180px;"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- STATUS --</b-form-select-option>
                              <b-form-select-option :value="null">ALL STATUS</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <!-- Coming From -->
                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_ship_locsub"
                            :options="available_ship_locsubs"
                            size="sm"
                            style="width: 180px;"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- COMING FROM --</b-form-select-option>
                              <b-form-select-option :value="null">ALL LOCATIONS</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <!-- Order Type -->
                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_order_type"
                            :options="available_order_types"
                            size="sm"
                            style="width: 180px;"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- ORDER TYPE --</b-form-select-option>
                              <b-form-select-option :value="null">ALL TYPES</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                      </b-alert>

                    </b-collapse>
                </div>
            </div>
        </div>

        <div style="width: 100%; padding: 5px; min-height: 200px;">
            <div>
                <div v-if="items_being_loaded == true">
                    <loading
                    :active="true"
                    :can-cancel="false"
                    :is-full-page="false">
                    </loading>

                </div>
                <div v-else>
                    <div v-if="items.length > 0" class="diver">
                        <table style="width: 100%;">
                            <thead>
                                <tr>
                                    <td class="srr" style="width: 120px;" @click="sortby('invoice_id')">
                                        INVOICE #
                                    </td>

                                    <td class="srr" style="width: 100px;">
                                        DELIVERY DATE
                                    </td>

                                    <td class="srr" style="width: 100px;" @click="sortby('product_sku')">
                                        PRD SKU
                                    </td>

                                    <td class="srr" style="width: 250px;" @click="sortby('product_name')">
                                        PRD NAME
                                    </td>

                                    <td class="srr" style="width: 120px;" @click="sortby('order_type')">
                                        ORDER TYPE
                                    </td>

                                    <td class="srr" style="width: 50px;" @click="sortby('quantity')">
                                        QTY
                                    </td>

                                    <td class="srr" style="width: 250px;" @click="sortby('locsub')">
                                        ITEM PICK FROM
                                    </td>

                                    <td class="srr" style="width: 250px;" @click="sortby('ship_locsub')">
                                        COMING FROM
                                    </td>

                                    <td class="srr" style="width: 250px;" @click="sortby('drop_locsub')">
                                        DELIVERY LOC
                                    </td>

                                    <td class="srr" style="width: 80px;"@click="sortby('pickup_truck')">
                                        PICKUP TRUCK
                                    </td>

                                    <td class="srr" style="width:250px;" @click="sortby('state')">
                                        STATUS
                                    </td>

                                    <td class="srr" style="width:80px;">
                                        ACTION
                                    </td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="item,idx in filtered" v-bind:key="idx">
                                    <td class="srrv">
                                        {{ item.invoice_id }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.delivery_date }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.product_sku }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.product_name }}
                                    </td>

                                    <td class="srrv">
                                    <div v-if="item.order_type == 'home_delivery'">
                                        <b-alert show variant="primary" style="padding: 2px; font-size: 11px; text-align: center;">HD</b-alert>
                                    </div>
                                    <div v-else-if="item.order_type == 'store_pickup'">
                                        <b-alert show variant="warning" style="padding: 2px; font-size: 11px; text-align: center;">STORE PICKUP</b-alert>
                                    </div>
                                    <div v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                        <b-alert show variant="info" style="padding: 2px; font-size: 11px; text-align: center;">STORE TRANFER</b-alert>
                                    </div>
                                    <div v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                        <b-alert show variant="secondary" style="padding: 2px; font-size: 11px; text-align: center;">DAMAGE ORDER</b-alert>
                                    </div>
                                    <div v-else>
                                        {{item.order_type}}
                                    </div>
                                    </td>

                                    <td class="srrv">
                                        {{ item.quantity }}
                                    </td>

                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{item.locsub === "0" ? "MECCA WHOLESALE" : packet.locsubsdict[item.original_locsub || item.locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                              {{packet.locsubsdict[item.original_locsub]}}
                                        </span>
                                         <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                              {{packet.locsubsdict[item.original_locsub]}}
                                        </span>
                                    </td>

                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{packet.locsubsdict[item.ship_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                           {{packet.locsubsdict[item.locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                            {{packet.locsubsdict[item.ship_locsub]}}
                                        </span>
                                    </td>

                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                          {{packet.locsubsdict[item.drop_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                             {{packet.locsubsdict[item.drop_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                             {{packet.locsubsdict[item.drop_locsub]}}
                                        </span>
                                    </td>

                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{packet.trucksdict[item.truck]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                           {{packet.trucksdict[item.truck]}}
                                        </span>
                                         <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                         {{packet.trucksdict[item.pickup_truck] || 'NA'}}
                                        </span>
                                    </td>

                                    <td class="srrv">
                                       <b-form-select
                                        size="sm"
                                        :style="{textAlign: 'left'}"
                                        :options="getFilteredStates(item)"
                                        v-model="item.state"
                                        v-on:change="update_invoice_item_state(item)"
                                        :disabled="item.state !== 30 && packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK'"
                                    ></b-form-select>
                                    </td>

                                    <td class="srrv hidden-print">
                                        <button  @click="show_comments(item)">CMNT</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { BIconFunnelFill } from 'bootstrap-vue'

    import ItemComments from '@/components/importables/ItemComments'

    export default {
        name: "Incoming",
        components: {flatPickr, Loading, ItemComments, DatePicker},
        data: function(){
            return {
                items: [],
                date_range: [],
                picked_date_range: null,
                dates: [],
                drop_location: null,
                active_date:null,
                years: [
                    {value: 2022, text: 2022},
                    {value: 2023, text: 2023},
                    {value: 2024, text: 2024},
                    {value: 2025, text: 2025},
                    {value: 2026, text: 2026},
                    {value: 2027, text: 2027},
                    {value: 2028, text: 2028},
                    {value: 2029, text: 2029},
                    {value: 2030, text: 2030},
                    {value: 2031, text: 2031},
                    {value: 2032, text: 2032},
                    {value: 2033, text: 2033},
                    {value: 2034, text: 2034},
                    {value: 2035, text: 2035},
                ],
                months: [
                    {value: 1, text: 1},
                    {value: 2, text: 2},
                    {value: 3, text: 3},
                    {value: 4, text: 4},
                    {value: 5, text: 5},
                    {value: 6, text: 6},
                    {value: 7, text: 7},
                    {value: 8, text: 8},
                    {value: 9, text: 9},
                    {value: 10, text: 10},
                    {value: 11, text: 11},
                    {value: 12, text: 12},
                ],
                year: null,
                month: null,
                picked_date: null,
                picked_location_id: null,
                picked_pickup_truck: null,
                selected_ship_locsub: null,
                available_ship_locsubs: [],
                packet: {},
                items_being_loaded: false,
                dates_being_loaded: false,
                current_date: null,
                type: 'incoming',
                locsubs: [],
                locsub: null,
                states: mappings.states.map(function(d){
                    let stateOption = {...d};

                    if(d.value == 13) stateOption.text = "DROPPED AT STORE";
                    if(d.value == 4) stateOption.text = "RECEIVED FROM MECCA SHIPPING";
                    if(d.value == -4) stateOption.text = "CANT RECEIVED FROM MECCA SHIPPING";
                    if(d.value == 5) stateOption.text = "READY TO SHIP";
                    if(d.value == -5) stateOption.text = "CANT READY TO SHIP";

                    return stateOption;
                }),
                states_outgoing_current: mappings.states,
                states_outgoing_new: mappings.states,
                states_dict: mappings.states_dict,
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                comments_dict: {},
                sort_asc: true,
                trucks: [],
                incoming_types: [
                    {value: null, text: "ALL"},
                    {value: "CUSTOMER_ORDER", text: "CUSTOMER ORDER"},
                    {value: "STORE_TRANSFER_ORDER", text: "STORE TRANSFER ORDER"},
                ],
                selected_date: null,
                selected_driver: null,
                selected_status: null,
                selected_drop_location: null,
                available_dates: [],
                available_drivers: [],
                available_statuses: [],
                available_drop_locations: [],
                selected_order_type: null,
        available_order_types: [],
                picked_incoming_type: null,
                selected_state: null,
                filtersVisible: false,
                isMobile: false,
            }
        },
        mounted: function() {
          this.handleResize();
          window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
          window.removeEventListener('resize', this.handleResize);
        },
        computed: {
               filtered: function(){
        let that = this;
        return this.items.filter(function(d){
            // Date filter
            const dateMatch = that.selected_date ? d.delivery_date === that.selected_date : true;

            // Driver filter
            const driverMatch = that.selected_driver ?
                (d.pickup_truck == that.selected_driver || d.truck == that.selected_driver) : true;

            // Status filter
            const statusMatch = that.selected_status ?
                that.getStatusText(d.state) === that.selected_status : true;

            // Ship Location filter
            const shipLocsubMatch = that.selected_ship_locsub ?
                d.ship_locsub == that.selected_ship_locsub : true;

            // Order Type filter - NEW
            const orderTypeMatch = that.selected_order_type ?
                that.getOrderTypeForFilter(d) === that.selected_order_type : true;

            return dateMatch && driverMatch && statusMatch && shipLocsubMatch && orderTypeMatch;
        });
    }
        },
        watch: {
         selected_date: function(newDate) {
        this.updateAvailableDrivers();
        this.updateAvailableStatuses();
        this.updateAvailableShipLocsubs();
        this.updateAvailableOrderTypes(); // NEW
    },
    items: function(newItems) {
        this.updateAvailableDates();
        this.updateAvailableDrivers();
        this.updateAvailableStatuses();
        this.updateAvailableShipLocsubs();
        this.updateAvailableOrderTypes(); // NEW
    }
        },
        methods: {
          handleResize() {
            this.isMobile = window.innerWidth < 768;
          },
             getOrderTypeForFilter(item) {
        if (item.incoming_type === 'STORE_TRANSFER_ORDER') {
            return 'store_transfer';
        }
        return item.order_type; // 'home_delivery' or 'store_pickup'
    },

    // Method to update available order types
    // Method to update available order types
updateAvailableOrderTypes() {
    const orderTypeCounts = {};

    this.items.forEach(item => {
        if (!this.selected_date || item.delivery_date === this.selected_date) {
            const orderType = this.getOrderTypeForFilter(item);
            let displayText = '';

            switch(orderType) {
                case 'home_delivery':
                    displayText = 'HOME DELIVERY';
                    break;
                case 'store_pickup':
                    displayText = 'STORE PICKUP';
                    break;
                case 'store_transfer':
                    displayText = 'STORE TRANSFER';
                    break;
                default:
                    displayText = orderType || 'UNKNOWN';
            }

            if (orderType) {
                // Fixed: Remove optional chaining
                const existingCount = orderTypeCounts[orderType] ? orderTypeCounts[orderType].count : 0;
                orderTypeCounts[orderType] = {
                    name: displayText,
                    count: existingCount + 1
                };
            }
        }
    });

    this.available_order_types = Object.keys(orderTypeCounts).map(orderType => ({
        value: orderType,
        text: `${orderTypeCounts[orderType].name} (${orderTypeCounts[orderType].count})`
    })).sort((a, b) => a.text.localeCompare(b.text));
},
            updateAvailableShipLocsubs() {
    const shipLocsubCounts = {};

    this.items.forEach(item => {
        if (!this.selected_date || item.delivery_date === this.selected_date) {
            const shipLocsub = item.ship_locsub;
            let locationName = '';

            if (item.incoming_type == 'CUSTOMER_ORDER') {
                locationName = this.packet.locsubsdict[shipLocsub] || shipLocsub;
            } else if (item.incoming_type == 'STORE_TRANSFER_ORDER') {
                locationName = this.packet.locationsdict[shipLocsub] || shipLocsub;
            }

            if (locationName) {
                const existingCount = shipLocsubCounts[shipLocsub] ? shipLocsubCounts[shipLocsub].count : 0;
                shipLocsubCounts[shipLocsub] = {
                    name: locationName,
                    count: existingCount + 1
                };
            }
        }
    });

    this.available_ship_locsubs = Object.keys(shipLocsubCounts).map(shipLocsubId => ({
        value: shipLocsubId,
        text: `${shipLocsubCounts[shipLocsubId].name} (${shipLocsubCounts[shipLocsubId].count})`
    })).sort((a, b) => a.text.localeCompare(b.text));
},
      getFilteredStates(item) {
    let userrole = this.packet.userDetails.userrole;
    
    // Show ALL states to ALL users
    const allStates = this.states;
    
    // Business logic for state transitions
    const shouldEnableState = (stateValue) => {
        // Admin can select everything
        if (userrole === "admin") {
            return true;
        }
        
        // For non-admin users:
        const allowedForNonAdmin = [13, 4, -4, 5, -5];
        
        // Only allow selection if current state is in allowed states
        if (!allowedForNonAdmin.includes(item.state)) {
            // If current state is not in allowed states, only current state is selectable
            return stateValue === item.state;
        }
        
        // If current state IS in allowed states, user can select from allowed states
        return allowedForNonAdmin.includes(stateValue);
    };
    
    // Return all states with enabling logic
    return allStates.map(state => {
        const enable = shouldEnableState(state.value);
        const isCurrent = state.value === item.state;
        
        return {
            ...state,
            disabled: !enable,
            // Optionally mark current state
            text: isCurrent ? `${state.text}` : state.text,
            // Add visual styling
            style: isCurrent ? { fontWeight: 'bold', backgroundColor: '#f0f8ff' } : {}
        };
    });
},
            getStatusText(state) {
                const statusObj = mappings.states.find(s => s.value === state);
                return statusObj ? statusObj.text : "UNKNOWN";
            },
            updateAvailableDates() {
                const dateCounts = {};
                this.items.forEach(item => {
                    if (item.delivery_date) {
                        dateCounts[item.delivery_date] = (dateCounts[item.delivery_date] || 0) + 1;
                    }
                });

                this.available_dates = Object.keys(dateCounts).map(date => ({
                    value: date,
                    text: `${date} (${dateCounts[date]})`
                }));

                // // Auto-select the first date if none selected and we have dates
                // if (this.available_dates.length > 0 && !this.selected_date) {
                //     this.selected_date = this.available_dates[0].value;
                // }
                this.selected_date = null;
            },
            updateAvailableDrivers() {
                const driverSet = new Set();

                this.items.forEach(item => {
                    if (!this.selected_date || item.delivery_date === this.selected_date) {
                        if (item.pickup_truck && this.packet.trucksdict[item.pickup_truck]) {
                            driverSet.add(item.pickup_truck);
                        }
                        if (item.truck && this.packet.trucksdict[item.truck]) {
                            driverSet.add(item.truck);
                        }
                    }
                });

                this.available_drivers = Array.from(driverSet).map(driverKey => ({
                    value: driverKey,
                    text: this.packet.trucksdict[driverKey] || driverKey
                })).sort((a, b) => a.text.localeCompare(b.text));
            },
            updateAvailableStatuses() {
                const statusCounts = {};

                this.items.forEach(item => {
                    if (!this.selected_date || item.delivery_date === this.selected_date) {
                        const statusText = this.getStatusText(item.state);
                        statusCounts[statusText] = (statusCounts[statusText] || 0) + 1;
                    }
                });

                this.available_statuses = Object.keys(statusCounts).map(statusText => ({
                    value: statusText,
                    text: `${statusText} (${statusCounts[statusText]})`
                })).sort((a, b) => a.text.localeCompare(b.text));
            },
            updateAvailableDropLocations() {
                const dropLocationCounts = {};

                this.items.forEach(item => {
                    if (!this.selected_date || item.delivery_date === this.selected_date) {
                        const dropLocation = item.drop_location;
                        const locationName = this.packet.locationsdict[dropLocation] || dropLocation;
                        if (locationName) {
                            // Fixed: Remove optional chaining
                            const existingCount = dropLocationCounts[dropLocation] ? dropLocationCounts[dropLocation].count : 0;
                            dropLocationCounts[dropLocation] = {
                                name: locationName,
                                count: existingCount + 1
                            };
                        }
                    }
                });

                this.available_drop_locations = Object.keys(dropLocationCounts).map(locationId => ({
                    value: locationId,
                    text: `${dropLocationCounts[locationId].name} (${dropLocationCounts[locationId].count})`
                })).sort((a, b) => a.text.localeCompare(b.text));
            },
            allowed: function(item){
                let status = true
                let allowed_item = this.allowed_item(item);
                let filtered_location = this.filtered_location(item);
                let filtered_pickup_truck = this.filtered_pickup_truck(item);

                if (allowed_item && filtered_location && filtered_pickup_truck){
                    status = true
                }
                else {
                    status = false
                }
                return status
            },
            allowed_item: function(item){
                let status = true;
                let userrole = this.packet.userDetails.userrole;
                let item_location_id = item.drop_location;

                if (userrole == "admin" || userrole == "officeuser") {
                    status = true;
                }
                else {
                    if (this.packet.userDetails.properties.location_id) {
                        let location_id = parseInt(this.packet.userDetails.properties.location_id);
                        if (location_id == item.item_location_id){
                            status = true
                        }
                        else {
                            status = false
                        }
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },
            filtered_location: function(item){
                let status = true;
                if (this.picked_location_id) {
                    if (item.drop_location == this.picked_location_id){
                        status = true;
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },
            filtered_pickup_truck: function(item){
                let status = true;
                if (this.picked_pickup_truck) {
                    if (item.pickup_truck == this.picked_pickup_truck){
                        status = true;
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },
            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid= item.itemid;
                this.$bvModal.show("modal-comments");
            },
         update_invoice_item_state: function(item){
    let path = "/api/sales/update_invoice_item_state/"
    let that = this;

    // Store original state for rollback
    const originalState = item.state;

    // Debug: Check what incoming_type we have
    console.log("Item incoming_type:", item.incoming_type);
    console.log("Item order_type:", item.order_type);
    console.log("Full item:", JSON.parse(JSON.stringify(item)));

    // Skip if store transfer order (as per your existing logic)
    // if (item.incoming_type == 'STORE_TRANSFER_ORDER'){
    //     return;
    // }

    // Determine incoming_type - use item.incoming_type if available
    let incomingType = item.incoming_type || '';
    
    // If not set, try to determine from available data
    if (!incomingType) {
        if (item.order_type === 'home_delivery' || item.order_type === 'store_pickup') {
            incomingType = 'CUSTOMER_ORDER';
        } else if (item.invoice_id && item.invoice_id.toString().includes('TRANSFER')) {
            incomingType = 'STORE_TRANSFER_ORDER';
        } else if (item.invoice_id && item.invoice_id.toString().includes('DAMAGE')) {
            incomingType = 'DAMAGE_ORDER';
        } else {
            incomingType = 'CUSTOMER_ORDER'; // Default
        }
    }

    // Prepare data with all necessary fields
    let data = {
        invoice_id: item.invoice_id, 
        itemid: item.itemid, 
        state: item.state, 
        changed_by: this.packet.userDetails.username, 
        product_sku: item.product_sku, 
        quantity: item.quantity,
        // CRITICAL: Include incoming_type
        incoming_type: incomingType,
        // Include location information
        drop_location: item.drop_location,
        drop_locsub: item.drop_locsub,
        ship_locsub: item.ship_locsub,
        original_locsub: item.original_locsub,
        // Include truck information
        pickup_truck: item.pickup_truck
    };

    console.log("Sending update data:", data);

    let s = function(response) {
        if (response.data.error){
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
            // Rollback state on error
            item.state = originalState;
            that.$forceUpdate();
        }
        else {
            that.$bvToast.toast(
                "Success updating item state.",
                {title: "Success", autoHideDelay: 1500, variant:"success"}
            );
            // Refresh data after successful update
            setTimeout(() => {
                that.fetch_init2();
            }, 500);
        }
    }

    let f = function(error) {
        console.log(error)
        that.$bvToast.toast(
            "Error updating item state.",
            {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        // Rollback state on error
        item.state = originalState;
        that.$forceUpdate();
    }
    
    Requestor.postAsync(path, data, s, f);
},
            fetch_init2: function(){
    let path = "/api/sales/get_incoming_items_for_date_range_store_with_transfer/"
    let that = this;

    let dateRange = this.date_range && this.date_range.length > 0
        ? this.date_range.filter(d => d !== null)
        : [moment().format("MM-DD-YYYY"), moment().format("MM-DD-YYYY")];

    let data = {
        date_range: dateRange,
        drop_location: this.drop_location
    };

    if (!data.drop_location && this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id){
        this.$bvToast.toast(
            "Please select an incoming location",
            {title: "Error", autoHideDelay: 1500, variant:"warning"}
        );
        return;
    }

    let s = function(response) {
        that.items_being_loaded = false;

        if (response && response.data && response.data.result){
            that.items = response.data.result;
            // Reset filters after loading new data
            that.selected_date = null;
            that.selected_driver = null;
            that.selected_status = null;
            that.selected_ship_locsub = null;
            that.selected_order_type = null; // NEW
        } else {
            let errorMsg = "Unknown error occurred";
            if (response && response.data && response.data.error) {
                errorMsg = response.data.error;
            }
            that.$bvToast.toast(
                errorMsg,
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
            that.items = [];
        }
    }

    let f = function(error) {
        that.items_being_loaded = false;
        console.error("API Error:", error);

        let errorMsg = "Network error loading incoming items";
        if (error && error.response && error.response.data && error.response.data.error) {
            errorMsg = error.response.data.error;
        }

        that.$bvToast.toast(
            errorMsg,
            {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        that.items = [];
    }

    this.items_being_loaded = true;
    this.items = [];
    Requestor.postSync(path, data, s, f);
},
            get_incoming_items_for_date: function(){
                let path = "/api/sales/get_incoming_items_for_date/"
                let that = this;
                let data = {date: this.picked_date};
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                this.items = [];
                Requestor.postSync(path, data, s, f);
            },
            get_incoming_dates_for_year_month: function(){
                let path = "/api/sales/get_incoming_dates_for_year_month/"
                let that = this;
                let data = {year: this.year, month: this.month};
                if (this.packet.userDetails.properties.location_id){
                    data.location_id = this.packet.userDetails.properties.location_id;
                }
                let s = function(response) {
                    if (response.data.result){
                        that.dates = response.data.result;
                        that.dates = that.dates.map(function(d){
                            return {value: d.date, text: d.date + ' ('+d.nitems+')' }
                        });
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.dates_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming dates.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.dates_being_loaded = false;
                }

                this.dates = [];
                this.items = [];
                this.picked_date = null;
                this.picked_location = null;
                Requestor.postAsync(path, data, s, f);
            },
            fetch_prereqs: function(){
            },
            fetch: function(type){
                this.type = type;
                this.items = []
                this.dates = []
                this.active_date = null;
                this.locsub = null;
            },
            sortby: function(key,mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items,key,mapper)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items,key,mapper)
                }
                this.sort_asc = !this.sort_asc;
            },
            set_dates: function(value){
                let start = null;
                let end = null;

                if(value == 'today') {
                    start = moment().format("MM-DD-YYYY");
                    end = moment().format("MM-DD-YYYY");
                }
                if(value == 'yesterday') {
                    start = moment().add(-1, 'days').format("MM-DD-YYYY");
                    end = moment().add(-1, 'days').format("MM-DD-YYYY");
                }
                if(value == 'this_week') {
                    start = moment().startOf('week').format("MM-DD-YYYY");
                    end = moment().endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'last_week') {
                    start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'this_month') {
                    start = moment().startOf('month').format("MM-DD-YYYY");
                    end = moment().endOf('month').format("MM-DD-YYYY");
                }
                if(value == 'last_month') {
                    start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY");
                }

                if (start && end) {
                    this.date_range = [start , end]
                    this.picked_date_range = value;
                }
            },
            get_locations: function(){
                let output = [
                    {value: null, text: "PICK LOCATION", disabled: true}
                ];
                let user_location = this.packet.userDetails.properties.location_id;

                const MECCA_SHIPPING_ID = 47;

                if (user_location){
                    output = this.packet.locations.filter(function(d){
                        return d.value == user_location && d.value != MECCA_SHIPPING_ID;
                    });
                }
                else {
                    output = output.concat(this.packet.locations.filter(function(d){
                        return d.text != 'All' &&
                               d.value != 46 &&
                               d.value != 44 &&
                               d.value != MECCA_SHIPPING_ID &&
                               d.value != 40 &&
                               d.value != 41 &&
                               d.value != 42;
                    }))
                }

                return output
            },
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.trucks = this.packet.trucks;

            if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                let userLocation = this.packet.locations.find(item => [this.packet.userDetails.properties.location_id].includes(item.value))
                if (userLocation) {
                    this.drop_location = userLocation.value
                    this.fetch_init2();
                }
            };
        }
    }
</script>

<style scoped>
    /* Add these styles to your existing CSS section */
select option:disabled {
    color: #888 !important;
    font-style: italic;
    background-color: #f5f5f5 !important;
}

select option {
    padding: 8px 12px !important;
    font-size: 13px !important;
}

/* Different styling for enabled vs disabled options */
select option:not(:disabled) {
    font-weight: 600;
    background-color: white !important;
}

select option[disabled] {
    border-bottom: 1px solid #e0e0e0;
}

/* Hover effect for enabled options */
select option:not(:disabled):hover {
    background-color: #e8f5e9 !important;
}

/* Make the dropdown wider to accommodate all text */
select[size="sm"] {
    min-width: 250px !important;
}

/* Style for the dropdown when it contains disabled options */
select option[value=""] {
    font-style: normal !important;
    font-weight: bold !important;
    background: #f8f9fa !important;
}
    .diver {
        overflow: auto;
        width: 100%;
        height: 800px;
    }
    .srr {
        font-size: 12px;
        text-align: center;
        font-weight: bold;
        background: rgb(60, 60, 60);
        color: white;
        border: 1px solid #ffffff;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }
    table {
        table-layout: fixed;
        width: 100%;
    }
    .ipt_tdr {
        background: none;
        text-align: center;
        font-size: 12px;
    }

    .ipt_tdhr {
        background: #343a40;
        color: white;
        font-weight: bold;
        text-align: center;
        font-size: 12px;
        border: 1px solid white;
    }
    @media (max-width: 768px) {
        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/IncomingOutGoing/StoreReceivingTransferOrders.vue